<template lang="html">
  <el-row>
    <el-col >
      <el-row :class="[qdata.achievement==0?'bg-eee':'bg-err', 'pd-tb10', 'pd-lr10', 'border-radio10']">
        <div class="title">
          <slot name="order"></slot><span v-html="qdata.question"></span>
        </div>
        <div class="option">
          <ul>
            <li
              :class="[qdata.answer.split(',').includes((index).toString())?'activer':'']"
              :key="index"
              v-for="(option,index) in qdata.options">
              {{index | indexTransform}}.
              <span v-html="option"></span>
            </li>
          </ul>
        </div>
        <div class="awser">
          考生选择答案：<span v-if="data.length"><span v-for="awser in data" >{{awser | indexTransform}}</span></span>
          <span v-else>考生未做答</span>
        </div>
        <div class="analysis">
          解析：{{qdata.remark}}
        </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Singleac',
  props:['qdata'],
  data() {
    return {
      data: []
    }
  },
  created(){
    let str = this.qdata.rightAnswer.toString()
    if(str.length){
      let rightArr = this.qdata.rightAnswer.toString().split(',')
      if(rightArr.length){
        this.data = rightArr
      }
    }

  },
  filters: {
    indexTransform: function (value) {
        value = Number(value)
        return String.fromCharCode(65 + parseInt(value));      
    }
  },
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.bg-err{
  background: rgba(255, 0, 0, 0.15);
}
.awser,.analysis{
  font-size: 14px;
  padding-bottom: 10px;
  padding-left: 5px;
  color: #666;
}
.option{
  font-size: 14px;
  margin: 15px 5px;
  li{
    padding: 10px 0;
     span{
      line-height: 16px;
    }
  }
  li.activer{
    color: #409EFF;
  }
  li.error{
    color: red;
  }
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
